import { DEFAULT_CREATOR_THEME } from '../constants/Theme.constants.js';

var getColorsFromCreatorTheme = function (theme) {
    return (theme === null || theme === void 0 ? void 0 : theme.colors) || DEFAULT_CREATOR_THEME.colors;
};

export { getColorsFromCreatorTheme };
//# sourceMappingURL=Theme.utils.js.map
